'use client'

import { createContext, type ReactNode, useContext, useMemo } from 'react'

const ComponentTrackingContext = createContext<{ component: string } | null>(null)

export function useComponentTracking() {
	return useContext(ComponentTrackingContext)
}

export function ComponentTrackingProvider({
	component,
	children,
}: {
	component: string
	children: ReactNode
}) {
	const value = useMemo(() => ({ component }), [component])

	return (
		<ComponentTrackingContext.Provider value={value}>{children}</ComponentTrackingContext.Provider>
	)
}
